import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  icon: PropTypes.node,
  children: PropTypes.node,
};

const CardElementPlaceholder = ({ icon, children, className }) => {
  const classes = classNames({
    'card-element-placeholder': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      {icon && <span className="card-element-placeholder-icon">{icon}</span>}
      {children && (
        <div className="card-element-placeholder-children">{children}</div>
      )}
    </div>
  );
};

CardElementPlaceholder.propTypes = propTypes;

export default CardElementPlaceholder;
